<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1></h1>
<p><em>“Like arrows in the hand of a warrior, so are the children of one’s youth.”</em></p>
<p style="text-align: right;"><strong><em>Psalm 124:4</em></strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?1e262c87